export function buildInboxTicketTitle(ticket: {
  title: string | null
  projectName: string | null
  issueCategory: string | null
  affectedSystem: string | null
  lastMessage: string | null
}) {
  const existingTitle = ticket.title?.trim()
  if (existingTitle) return existingTitle

  const category = ticket.issueCategory?.trim()
  const system = ticket.affectedSystem?.trim()
  const project = ticket.projectName?.trim()

  if (system && category) return `${system} ${category.toLowerCase()} issue`
  if (project && category) return `${project} ${category.toLowerCase()} issue`
  if (category) return `${category} issue`
  if (system) return `${system} issue`
  if (project) return `${project} issue`

  const words = ticket.lastMessage
    ?.replace(/^\s*\d+\.\s*/, '')
    .split(/\s+/)
    .filter(Boolean) ?? []
  const messageWords = words.slice(0, 6).join(' ')

  return messageWords ? `${messageWords}${words.length > 6 ? '...' : ''}` : 'Ticket'
}
